import { useEffect, useState } from "react";

export const useLocalStorage = <Value>(key: string, validator: (item: Value) => boolean, defaultValue: Value) => {
  const [value, setValue] = useState<Value>(() => {
    try {
      const parsedItem = JSON.parse(localStorage.getItem(key) || "") as Value;
      return validator(parsedItem) ? parsedItem : defaultValue;
    } catch {
      return defaultValue;
    }
  });
  useEffect(() => localStorage.setItem(key, JSON.stringify(value)), [key, value]);
  return [value, setValue] as const;
};
